"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5634],{

/***/ 73885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ HeaderHome_LocationSelect; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/PopOver/index.tsx + 2 modules
var PopOver = __webpack_require__(20951);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Button.tsx + 1 modules
var Button = __webpack_require__(40364);
// EXTERNAL MODULE: ./src/constants/environment.ts
var environment = __webpack_require__(7181);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 40 modules
var axios = __webpack_require__(6154);
;// CONCATENATED MODULE: ./src/modules/Desktop/Home/HeaderHome/LocationSelect/SelectCity.tsx







/* eslint-disable @next/next/no-img-element */ const SelectCity = (param)=>{
    let { valueLocation , setValueLocation , setActviveTab , allowConfirm , onConfirm  } = param;
    var _valueLocation_city;
    const [data, setData] = (0,react.useState)([]);
    const [loading, setLoading] = (0,react.useState)(false);
    const [search, setSearch] = (0,react.useState)("");
    const listDataRender = (0,react.useMemo)(()=>{
        var _unionBy;
        return (_unionBy = (0,lodash.unionBy)(valueLocation.city, data, "_id")) === null || _unionBy === void 0 ? void 0 : _unionBy.filter((item)=>{
            return item === null || item === void 0 ? void 0 : item.title.toLocaleLowerCase().includes(search.toLocaleLowerCase());
        });
    }, [
        data,
        search,
        valueLocation.city
    ]);
    const getData = (0,react.useCallback)(async ()=>{
        setLoading(true);
        try {
            var _res_data;
            const res = await axios/* default.request */.Z.request({
                baseURL: environment/* MEEY_REVIEW_API_URL */.HG,
                url: "/v1/cities",
                params: {
                    limit: 500
                }
            });
            setData((_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.results);
        } catch (error) {} finally{
            setLoading(false);
        }
    }, []);
    (0,react.useEffect)(()=>{
        getData();
    }, [
        getData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("flex gap-1 items-center mx-3 px-3 py-2 bg-[rgba(0,0,0,0.05)] rounded", allowConfirm ? "mb-2" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "mrv mrv-search text-fs-20"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        value: search,
                        onChange: (e)=>{
                            var _e_target_value;
                            return setSearch((_e_target_value = e.target.value) === null || _e_target_value === void 0 ? void 0 : _e_target_value.slice(0, 100));
                        },
                        placeholder: "T\xecm Tỉnh/Th\xe0nh phố",
                        className: "h-[28px] mr-5 w-full text-base bg-transparent"
                    })
                ]
            }),
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full h-full flex justify-center py-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "dot-flashing"
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    allowConfirm ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-end border-b border-b-grey-300 mx-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-grey-600 py-2.5 px-1 flex items-center gap-1 cursor-pointer",
                            onClick: ()=>{
                                setValueLocation({
                                    city: [],
                                    district: [],
                                    ward: []
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "mrv mrv-restart_alt"
                                }),
                                "Đặt lại"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)("w-full h-full overflow-auto px-3", allowConfirm ? "mb-0" : "mb-3"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                onClick: ()=>{
                                    setValueLocation({
                                        city: [],
                                        district: [],
                                        ward: []
                                    });
                                },
                                className: "py-3 flex items-center hover:bg-[rgba(0,0,0,0.05)] duration-300 cursor-pointer ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: (0,clsx_m/* default */.Z)("mrv mrv-check text-fs-24 mr-2", !(valueLocation === null || valueLocation === void 0 ? void 0 : (_valueLocation_city = valueLocation.city) === null || _valueLocation_city === void 0 ? void 0 : _valueLocation_city.length) ? "text-blue-500" : "text-transparent")
                                    }),
                                    "To\xe0n quốc"
                                ]
                            }),
                            listDataRender === null || listDataRender === void 0 ? void 0 : listDataRender.map((city)=>{
                                var _valueLocation_city;
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                    onClick: ()=>{
                                        setActviveTab("district");
                                        setValueLocation({
                                            city: [
                                                city
                                            ],
                                            district: [],
                                            ward: []
                                        });
                                    },
                                    className: "py-3 flex items-center hover:bg-[rgba(0,0,0,0.05)] duration-300 cursor-pointer ",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: (0,clsx_m/* default */.Z)("mrv mrv-check text-fs-24 mr-2", (valueLocation === null || valueLocation === void 0 ? void 0 : (_valueLocation_city = valueLocation.city) === null || _valueLocation_city === void 0 ? void 0 : _valueLocation_city.find((e)=>e._id === city._id)) ? "text-blue-500" : "text-transparent")
                                        }),
                                        city === null || city === void 0 ? void 0 : city.name
                                    ]
                                }, city._id);
                            })
                        ]
                    }),
                    allowConfirm ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-2 py-2 px-3 border-t border-t-grey-200",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                className: "w-full flex justify-center !text-grey-600 hover:!bg-transparent",
                                btnType: "link",
                                onClick: ()=>{
                                    setValueLocation({
                                        city: [],
                                        district: [],
                                        ward: []
                                    });
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "mrv mrv-restart_alt mr-2"
                                    }),
                                    "Đặt lại",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                className: "w-full flex justify-center",
                                btnType: "filled",
                                onClick: ()=>{
                                    onConfirm && onConfirm(valueLocation);
                                },
                                children: [
                                    "X\xe1c nhận",
                                    " "
                                ]
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ var LocationSelect_SelectCity = (SelectCity);

// EXTERNAL MODULE: ./src/utils/number.ts + 1 modules
var number = __webpack_require__(1495);
;// CONCATENATED MODULE: ./src/modules/Desktop/Home/HeaderHome/LocationSelect/SelectDistrict.tsx








/* eslint-disable @next/next/no-img-element */ const SelectDistrict = (param)=>{
    let { valueLocation , setValueLocation , setActviveTab , allowConfirm , onConfirm  } = param;
    const [data, setData] = (0,react.useState)([]);
    const [loading, setLoading] = (0,react.useState)(false);
    const [search, setSearch] = (0,react.useState)("");
    const listDataRender = (0,react.useMemo)(()=>{
        return (0,lodash.unionBy)(valueLocation.district, data, "_id").filter((e)=>e.title.toLowerCase().includes(search.toLowerCase()));
    }, [
        data,
        valueLocation.district,
        search
    ]);
    const getData = (0,react.useCallback)(async ()=>{
        setLoading(true);
        try {
            var _valueLocation_city, _res_data;
            const res = await axios/* default.request */.Z.request({
                baseURL: environment/* MEEY_REVIEW_API_URL */.HG,
                url: "/v1/districts",
                method: "post",
                data: {
                    limit: 500,
                    city: valueLocation === null || valueLocation === void 0 ? void 0 : (_valueLocation_city = valueLocation.city) === null || _valueLocation_city === void 0 ? void 0 : _valueLocation_city[0]._id
                }
            });
            setData((_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.results);
        } catch (error) {} finally{
            setLoading(false);
        }
    }, [
        valueLocation === null || valueLocation === void 0 ? void 0 : valueLocation.city
    ]);
    (0,react.useEffect)(()=>{
        getData();
    }, [
        getData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("flex gap-1 items-center mx-3 px-3 py-2 bg-[rgba(0,0,0,0.05)] rounded", allowConfirm ? "mb-2" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "mrv mrv-search text-fs-20"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        value: search,
                        onChange: (e)=>{
                            var _e_target_value;
                            return setSearch((_e_target_value = e.target.value) === null || _e_target_value === void 0 ? void 0 : _e_target_value.slice(0, 100));
                        },
                        placeholder: "T\xecm Quận/Huyện",
                        className: "h-[28px] mr-5 w-full text-base bg-transparent"
                    })
                ]
            }),
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full h-full flex justify-center py-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "dot-flashing"
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    allowConfirm ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between items-center border-b border-b-grey-300 mx-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text=grey-800 font-medium",
                                children: [
                                    valueLocation.district.length,
                                    " lựa chọn"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-grey-600 py-2.5 px-1 flex items-center gap-1 cursor-pointer",
                                onClick: ()=>{
                                    setValueLocation({
                                        city: valueLocation.city,
                                        district: [],
                                        ward: []
                                    });
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "mrv mrv-restart_alt"
                                    }),
                                    "Đặt lại"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("w-full h-full overflow-auto px-3", allowConfirm ? "mb-0" : "mb-3"),
                        children: listDataRender === null || listDataRender === void 0 ? void 0 : listDataRender.map((district)=>{
                            const cityTranslate = district;
                            const isSelect = valueLocation.district.find((item)=>item._id === district._id);
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                onClick: ()=>{
                                    var _valueLocation_district;
                                    setValueLocation({
                                        city: valueLocation.city,
                                        district: isSelect ? (_valueLocation_district = valueLocation.district) === null || _valueLocation_district === void 0 ? void 0 : _valueLocation_district.filter((item)=>item._id !== district._id) : [
                                            ...valueLocation.district,
                                            district
                                        ],
                                        ward: []
                                    });
                                },
                                className: "py-3 flex items-center hover:bg-[rgba(0,0,0,0.05)] duration-300 cursor-pointer ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: (0,clsx_m/* default */.Z)("mrv   text-fs-24 mr-2", isSelect ? "mrv-check_box text-blue-500" : "mrv-check_box_outline_blank")
                                    }),
                                    (0,number/* isNumeric */.kE)(cityTranslate === null || cityTranslate === void 0 ? void 0 : cityTranslate.name) ? cityTranslate.title : cityTranslate === null || cityTranslate === void 0 ? void 0 : cityTranslate.name
                                ]
                            }, district._id);
                        })
                    }),
                    allowConfirm ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-2 py-2 px-3 border-t border-t-grey-200",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                className: "w-full flex justify-center !text-grey-600 hover:!bg-transparent",
                                btnType: "link",
                                onClick: ()=>{
                                    setValueLocation({
                                        city: valueLocation.city,
                                        district: [],
                                        ward: []
                                    });
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "mrv mrv-restart_alt mr-2"
                                    }),
                                    "Đặt lại",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                className: "w-full flex justify-center",
                                btnType: "filled",
                                onClick: ()=>{
                                    onConfirm && onConfirm(valueLocation);
                                },
                                children: [
                                    "X\xe1c nhận",
                                    " "
                                ]
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ var LocationSelect_SelectDistrict = (SelectDistrict);

// EXTERNAL MODULE: ./src/constants/common-constant.ts
var common_constant = __webpack_require__(17785);
// EXTERNAL MODULE: ./node_modules/react-infinite-scroll-component/dist/index.es.js
var index_es = __webpack_require__(58533);
;// CONCATENATED MODULE: ./src/modules/Desktop/Home/HeaderHome/LocationSelect/SelectWard.tsx










/* eslint-disable @next/next/no-img-element */ const SelectWard = (param)=>{
    let { valueLocation , setValueLocation , allowConfirm , onConfirm  } = param;
    const [data, setData] = (0,react.useState)({
        results: [],
        totalResults: 0,
        totalPages: 0,
        page: 1
    });
    const [loading, setLoading] = (0,react.useState)(false);
    const [search, setSearch] = (0,react.useState)("");
    const listDataRender = (0,react.useMemo)(()=>{
        return (search === null || search === void 0 ? void 0 : search.length) ? data.results : (0,lodash.unionBy)(valueLocation.ward, data.results, "_id");
    }, [
        data.results,
        search,
        valueLocation.ward
    ]);
    const getData = (0,react.useCallback)(async (params)=>{
        setLoading(true);
        try {
            var _valueLocation_district;
            const res = await axios/* default.request */.Z.request({
                baseURL: environment/* MEEY_REVIEW_API_URL */.HG,
                url: "/v1/wards",
                method: "post",
                data: {
                    limit: 10,
                    page: 1,
                    name: search,
                    sort: "name:asc",
                    district: (_valueLocation_district = valueLocation.district) === null || _valueLocation_district === void 0 ? void 0 : _valueLocation_district.map((e)=>e._id),
                    ...params
                }
            });
            setData({
                ...res.data
            });
        } catch (error) {} finally{
            setLoading(false);
        }
    }, [
        search,
        valueLocation.district
    ]);
    const loadMoreData = (0,react.useCallback)(async (page)=>{
        setLoading(true);
        try {
            var _valueLocation_district;
            const res = await axios/* default.request */.Z.request({
                baseURL: environment/* MEEY_REVIEW_API_URL */.HG,
                url: "/v1/wards",
                method: "post",
                data: {
                    limit: 10,
                    page: page !== null && page !== void 0 ? page : 1,
                    name: search,
                    sort: "name:asc",
                    district: (_valueLocation_district = valueLocation.district) === null || _valueLocation_district === void 0 ? void 0 : _valueLocation_district.map((e)=>e._id)
                }
            });
            setData({
                ...res.data,
                results: page ? [
                    ...data.results,
                    ...res.data.results
                ] : res.data.results
            });
        } catch (error) {} finally{
            setLoading(false);
        }
    }, [
        data.results,
        search,
        valueLocation.district
    ]);
    (0,react.useEffect)(()=>{
        getData();
    }, []);
    const timeoutSearch = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("flex gap-1 items-center mx-3 px-3 py-2 bg-[rgba(0,0,0,0.05)] rounded flex-0", allowConfirm ? "mb-2" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "mrv mrv-search text-fs-20"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        value: search,
                        onChange: (e)=>{
                            var _e_target_value;
                            clearTimeout(timeoutSearch.current);
                            setSearch((_e_target_value = e.target.value) === null || _e_target_value === void 0 ? void 0 : _e_target_value.slice(0, 100));
                            if (!loading) timeoutSearch.current = setTimeout(()=>{
                                var _e_target_value;
                                getData({
                                    name: (_e_target_value = e.target.value) === null || _e_target_value === void 0 ? void 0 : _e_target_value.slice(0, 100)
                                });
                            }, common_constant/* TIMEOUT_LOAD_SEARCH */.XO);
                        },
                        onKeyUp: (e)=>{
                            if (e.key === "Enter" && !loading) {
                                var _e_target_value;
                                clearTimeout(timeoutSearch.current);
                                getData({
                                    name: (_e_target_value = e.target.value) === null || _e_target_value === void 0 ? void 0 : _e_target_value.slice(0, 100)
                                });
                            }
                        },
                        placeholder: "T\xecm Phường/X\xe3",
                        className: "h-[28px] mr-5 w-full text-base bg-transparent"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    allowConfirm ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between items-center border-b border-b-grey-300 mx-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text=grey-800 font-medium",
                                children: [
                                    valueLocation.ward.length,
                                    " lựa chọn"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-grey-600 py-2.5 px-1 flex items-center gap-1 cursor-pointer",
                                onClick: ()=>{
                                    setValueLocation({
                                        city: valueLocation.city,
                                        district: valueLocation.district,
                                        ward: []
                                    });
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "mrv mrv-restart_alt"
                                    }),
                                    "Đặt lại"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("w-full h-full overflow-auto px-3 flex-1"),
                        id: "scrollablePopup",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                            dataLength: data.results.length || 0,
                            hasMore: data.page < data.totalPages,
                            next: ()=>{
                                loadMoreData(data.page + 1);
                            },
                            scrollableTarget: "scrollablePopup",
                            className: " md:gap-4 gap-1 overflow-auto w-full",
                            loader: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "px-4 flex items-center justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "dot-flashing"
                                })
                            }),
                            children: listDataRender === null || listDataRender === void 0 ? void 0 : listDataRender.map((ward)=>{
                                const isSelect = valueLocation.ward.find((item)=>item._id === ward._id);
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    onClick: ()=>{
                                        var _valueLocation_ward;
                                        setValueLocation({
                                            city: valueLocation.city,
                                            district: valueLocation.district,
                                            ward: isSelect ? (_valueLocation_ward = valueLocation.ward) === null || _valueLocation_ward === void 0 ? void 0 : _valueLocation_ward.filter((item)=>item._id !== ward._id) : [
                                                ...valueLocation.ward,
                                                ward
                                            ]
                                        });
                                    },
                                    className: "py-3 flex items-center hover:bg-[rgba(0,0,0,0.05)] duration-300 cursor-pointer ",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: (0,clsx_m/* default */.Z)("mrv   text-fs-24 mr-2", isSelect ? "mrv-check_box text-blue-500" : "mrv-check_box_outline_blank")
                                        }),
                                        (0,number/* isNumeric */.kE)(ward === null || ward === void 0 ? void 0 : ward.name) ? ward.title : ward === null || ward === void 0 ? void 0 : ward.name
                                    ]
                                }, ward._id);
                            })
                        })
                    }),
                    allowConfirm ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-2 py-2 px-3 border-t border-t-grey-200 flex-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                className: "w-full flex justify-center !text-grey-600 hover:!bg-transparent",
                                btnType: "link",
                                onClick: ()=>{
                                    setValueLocation({
                                        city: valueLocation.city,
                                        district: valueLocation.district,
                                        ward: []
                                    });
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "mrv mrv-restart_alt mr-2"
                                    }),
                                    "Đặt lại",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                className: "w-full flex justify-center",
                                btnType: "filled",
                                onClick: ()=>{
                                    onConfirm && onConfirm(valueLocation);
                                },
                                children: [
                                    "X\xe1c nhận",
                                    " "
                                ]
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ var LocationSelect_SelectWard = (SelectWard);

;// CONCATENATED MODULE: ./src/modules/Desktop/Home/HeaderHome/LocationSelect/PopupSelectLocation.tsx






/* eslint-disable @next/next/no-img-element */ const tabs = [
    {
        label: "Tỉnh/Th\xe0nh phố",
        key: "city",
        child: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationSelect_SelectCity, {})
    },
    {
        label: "Quận/Huyện",
        key: "district",
        child: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationSelect_SelectDistrict, {})
    },
    {
        label: "Phường/X\xe3",
        key: "ward",
        child: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationSelect_SelectWard, {})
    }
];
const PopupSelectLocation = (param)=>{
    let { valueLocation , setValueLocation , allowConfirm , onConfirm  } = param;
    var _valueLocation_city, _valueLocation_district, _tabs_find;
    const [activeTab, setActviveTab] = (0,react.useState)("city");
    // const
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("px-4 py-3 font-medium cursor-pointer border-b border-b-grey-200 duration-300", activeTab === "city" ? "text-blue-500 !border-b-blue-500" : "", "hover:border-b-blue-500"),
                        onClick: ()=>setActviveTab("city"),
                        children: "Tỉnh/Th\xe0nh phố"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("px-4 py-3 font-medium cursor-pointer border-b border-b-grey-200 duration-300", "hover:border-b-blue-500", activeTab === "district" ? "text-blue-500 !border-b-blue-500" : "", !((_valueLocation_city = valueLocation.city) === null || _valueLocation_city === void 0 ? void 0 : _valueLocation_city.length) ? "text-grey-200 !cursor-not-allowed border-b-grey-200" : "", "hover:border-b-blue-500"),
                        onClick: ()=>valueLocation.city.length && setActviveTab("district"),
                        children: "Quận/Huyện"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("px-4 py-3 font-medium cursor-pointer border-b border-b-grey-200 duration-300", "hover:border-b-blue-500", activeTab === "ward" ? "text-blue-500 !border-b-blue-500" : "", !((_valueLocation_district = valueLocation.district) === null || _valueLocation_district === void 0 ? void 0 : _valueLocation_district.length) ? "text-grey-200 !cursor-not-allowed border-b-grey-200" : ""),
                        onClick: ()=>valueLocation.district.length && setActviveTab("ward"),
                        children: "Phường/X\xe3"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-[24rem] pt-3 overflow-auto flex flex-col",
                children: /*#__PURE__*/ (0,react.cloneElement)((_tabs_find = tabs.find((tab)=>tab.key === activeTab)) === null || _tabs_find === void 0 ? void 0 : _tabs_find.child, {
                    valueLocation,
                    setValueLocation,
                    setActviveTab,
                    allowConfirm,
                    onConfirm
                })
            })
        ]
    });
};
/* harmony default export */ var LocationSelect_PopupSelectLocation = (PopupSelectLocation);

;// CONCATENATED MODULE: ./src/modules/Desktop/Home/HeaderHome/LocationSelect/index.tsx






/* eslint-disable @next/next/no-img-element */ const LocationSelect = (param)=>{
    let { value , onChange , inputClassName , toolTipPosition , allowConfirm , onConfirm  } = param;
    const [valueLocation, setValueLocation] = (0,react.useState)({
        city: [],
        district: [],
        ward: []
    });
    const [open, setOpen] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        var _value_city, _value_district, _value_ward;
        setValueLocation({
            city: (_value_city = value === null || value === void 0 ? void 0 : value.city) !== null && _value_city !== void 0 ? _value_city : [],
            district: (_value_district = value === null || value === void 0 ? void 0 : value.district) !== null && _value_district !== void 0 ? _value_district : [],
            ward: (_value_ward = value === null || value === void 0 ? void 0 : value.ward) !== null && _value_ward !== void 0 ? _value_ward : []
        });
    }, [
        value
    ]);
    const showNameValue = (0,react.useMemo)(()=>{
        var _valueLocation_district, _valueLocation_city;
        return valueLocation.city.length || valueLocation.district.length || valueLocation.ward.length ? "".concat(valueLocation.ward.length ? valueLocation.ward.map((ward)=>ward.name).join(", ") + "," : "", " ").concat(((_valueLocation_district = valueLocation.district) === null || _valueLocation_district === void 0 ? void 0 : _valueLocation_district.length) ? valueLocation.district.map((district)=>district.name).join(", ") + "," : "", " ").concat(((_valueLocation_city = valueLocation.city) === null || _valueLocation_city === void 0 ? void 0 : _valueLocation_city.length) ? valueLocation.city.map((city)=>city.name).join(", ") : "") : "To\xe0n quốc";
    }, [
        valueLocation.city,
        valueLocation.district,
        valueLocation.ward
    ]);
    const toolTipValueName = (0,react.useMemo)(()=>{
        const listWardByDistrict = (0,lodash.groupBy)(valueLocation.ward, (e)=>e.deps[0]);
        return (valueLocation === null || valueLocation === void 0 ? void 0 : valueLocation.city.length) || (valueLocation === null || valueLocation === void 0 ? void 0 : valueLocation.district.length) || (valueLocation === null || valueLocation === void 0 ? void 0 : valueLocation.ward.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                Object.keys(listWardByDistrict).map((districtId)=>{
                    var _listWardByDistrict_districtId;
                    const currentDistrict = valueLocation.district.find((e)=>e._id === districtId);
                    const currentCity = valueLocation.city.find((e)=>{
                        var _currentDistrict_deps;
                        return e._id === (currentDistrict === null || currentDistrict === void 0 ? void 0 : (_currentDistrict_deps = currentDistrict.deps) === null || _currentDistrict_deps === void 0 ? void 0 : _currentDistrict_deps[0]);
                    });
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "",
                        children: [
                            (_listWardByDistrict_districtId = listWardByDistrict[districtId]) === null || _listWardByDistrict_districtId === void 0 ? void 0 : _listWardByDistrict_districtId.map((ward)=>ward.name + ", "),
                            " ",
                            currentDistrict.name + ", " + currentCity.name
                        ]
                    }, districtId);
                }),
                valueLocation.district.filter((item)=>{
                    return !valueLocation.ward.find((e)=>{
                        var _e_deps;
                        return (_e_deps = e.deps) === null || _e_deps === void 0 ? void 0 : _e_deps.includes(item._id);
                    });
                }).map((item)=>{
                    const currentCity = valueLocation.city.find((e)=>{
                        var _item_deps;
                        return e._id === (item === null || item === void 0 ? void 0 : (_item_deps = item.deps) === null || _item_deps === void 0 ? void 0 : _item_deps[0]);
                    });
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "",
                        children: item.name + ", " + (currentCity === null || currentCity === void 0 ? void 0 : currentCity.name)
                    }, item._id);
                }),
                valueLocation.city.filter((item)=>{
                    return !valueLocation.district.find((e)=>{
                        var _e_deps;
                        return (_e_deps = e.deps) === null || _e_deps === void 0 ? void 0 : _e_deps.includes(item._id);
                    });
                }).map((item)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "",
                        children: item.name
                    }, item._id);
                })
            ]
        }) : null;
    }, [
        valueLocation.city,
        valueLocation.district,
        valueLocation.ward
    ]);
    // useEffect(() => {
    //   if (open) lockScroll();
    //   else unlockScroll();
    //   // return () => {
    //   //   unlockScroll();
    //   // };
    // }, [open]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PopOver/* default */.Z, {
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationSelect_PopupSelectLocation, {
                valueLocation: valueLocation,
                setValueLocation: (data)=>{
                    setValueLocation(data);
                    onChange && onChange(data);
                },
                allowConfirm: allowConfirm,
                onConfirm: (value)=>{
                    setOpen(false);
                    onConfirm && onConfirm(value);
                }
            }),
            open: open,
            className: "h-full",
            onOpen: ()=>{
                setOpen(true);
            },
            onClose: ()=>{
                setOpen(false);
            },
            position: "bottom-right",
            dropdownClassName: "mt-4 rounded !p-0",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PopOver/* default */.Z, {
                trigger: "hover",
                content: toolTipValueName,
                position: toolTipPosition !== null && toolTipPosition !== void 0 ? toolTipPosition : "bottom-right",
                // className={clsx(
                //   "px-2 flex items-center border-r border-r-grey-200 rounded-none",
                //   inputClassName
                // )}
                className: "h-full",
                wrapTriggerClassName: "h-full",
                dropdownClassName: "!z-[20] !bg-[rgba(0,0,0,0.9)] text-white rounded overflow-auto flex flex-col gap-2 text-fs-14 px-4 py-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)("px-2 flex items-center border-r border-r-grey-200 rounded-none ", inputClassName),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-[8.5rem] line-clamp-1 select-none",
                            children: [
                                showNameValue,
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: (0,clsx_m/* default */.Z)("mrv mrv-keyboard_arrow_down text-fs-20 text-grey-500 ml-3 duration-300", open ? "rotate-180" : "rotate-0")
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var HeaderHome_LocationSelect = (LocationSelect);


/***/ }),

/***/ 51329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_MeeyImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3524);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33172);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40364);
/* harmony import */ var _Home_HeaderHome_SearchProject__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82620);
/* harmony import */ var _components_PopupAvatarUser__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84536);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _constants_environment__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7181);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86010);
/* harmony import */ var _components_PopupNotification__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8440);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_11__);













const ModalAddReview = next_dynamic__WEBPACK_IMPORTED_MODULE_11___default()(Promise.all(/* import() */[__webpack_require__.e(314), __webpack_require__.e(9510), __webpack_require__.e(1696), __webpack_require__.e(8762), __webpack_require__.e(2678), __webpack_require__.e(8703), __webpack_require__.e(2540), __webpack_require__.e(6140), __webpack_require__.e(3065)]).then(__webpack_require__.bind(__webpack_require__, 22881)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(22881)
            ]
    },
    ssr: false
});
const HeaderListSearchProject = (param)=>{
    let { isShowScrolHeader , showSearch  } = param;
    const { user , login  } = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_4__/* .useAuth */ .a)();
    const { push  } = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
    const [mounted, setMounted] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setMounted(true);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)("bg-white flex items-center justify-between h-14 w-full pl-10 pr-[60px] fixed duration-300  z-30 shadow-light-2", isShowScrolHeader ? "top-0" : "-top-full"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: "/",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MeeyImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    alt: "home",
                    src: _constants_environment__WEBPACK_IMPORTED_MODULE_9__/* .STATIC_DOMAIN */ .xm + "/logo_blue.svg",
                    resizeOnFly: false,
                    resizeOptions: {
                        width: 131,
                        height: 42
                    }
                })
            }),
            showSearch ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center w-[26.5rem] h-10 rounded-md py-2 pl-3 border border-solid border-grey-200",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "mrv mrv-search text-fs-20 text-grey-500"
                    }),
                    mounted ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Home_HeaderHome_SearchProject__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        showSuffixIcon: false,
                        className: "w-[calc(100%-32px)]",
                        allowClear: true
                    }) : null
                ]
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center gap-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalAddReview, {
                        buttonClassName: "h-9",
                        callBack: ()=>{
                            push("/");
                        }
                    }),
                    !user ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        color: "white",
                        onClick: login,
                        className: "meey-button meey-button-grey meey-button-outline py-2.5 px-4 h-9 flex items-center gap-1",
                        btnType: "outline",
                        prefixIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                            className: "mrv mrv-account_circle text-fs-18",
                            children: " "
                        }),
                        children: "Đăng nhập"
                    }) : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PopupNotification__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        isShowScrolHeader: isShowScrolHeader
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PopupAvatarUser__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeaderListSearchProject);


/***/ })

}]);